import type { Drug } from "../types";

export const mometasoneFuroateNasalSprayDrug: Drug = {
  id: "mometasone_furoate_nasal_spray",
  name: "Mometasone furoate nasal spray",
  drugClass: "intranasal corticosteroid",
  route: "nasal",
  administrationNote: "Shake well before use. Prime the spray before first use or if unused for several days.",
  formulations: [
    {
      id: "mometasone-50mcg-spray",
      type: "nasal_spray",
      strength: 50,
      strengthUnit: "mcg",
      actuationDose: 50,
      bottleActuations: 140,
    },
  ],
};
